/**
 * Serene Herbs PDP
 * Pack radios → quantity 1/2/3 with volume discounts 5%/10%/20%
 * Prices from catalog unit cents; no subscription UI.
 */
(function () {
  const root = document.querySelector('[data-serene-pdp]');
  if (!root) return;

  function money(cents) {
    const n = (Number(cents) || 0) / 100;
    return (
      '$' +
      n.toLocaleString('en-US', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      })
    );
  }

  let sharedQty = parseInt(root.getAttribute('data-default-qty') || '1', 10) || 1;
  if (![1, 2, 3].includes(sharedQty)) sharedQty = 1;

  function getForms() {
    return Array.from(root.querySelectorAll('product-form-component.serene-product-form'));
  }

  function selectedPackRadio(form) {
    return (
      form.querySelector('[data-pack-radio]:checked') ||
      form.querySelector('[data-pack-radio][data-qty="' + sharedQty + '"]')
    );
  }

  function updateShipHint(form, saleCents) {
    const hint = form.querySelector('[data-ship-hint]');
    if (!hint) return;
    const threshold = parseInt(form.getAttribute('data-free-ship-cents') || '9500', 10);
    if (saleCents >= threshold) {
      hint.textContent = 'This supply qualifies for FREE shipping ($95+).';
      hint.classList.add('is-qualified');
    } else {
      const remain = threshold - saleCents;
      hint.textContent = 'Add ' + money(remain) + ' more for FREE shipping.';
      hint.classList.remove('is-qualified');
    }
  }

  function syncForm(form) {
    const qtyInput = form.querySelector('[data-serene-qty], input[name="quantity"]');
    if (qtyInput) {
      qtyInput.value = String(sharedQty);
      qtyInput.dispatchEvent(new Event('input', { bubbles: true }));
      qtyInput.dispatchEvent(new Event('change', { bubbles: true }));
    }

    form.querySelectorAll('[data-pack-radio]').forEach((radio) => {
      const q = parseInt(radio.getAttribute('data-qty') || '0', 10);
      radio.checked = q === sharedQty;
    });

    const pack = selectedPackRadio(form);
    if (!pack) return;

    const saleCents = parseInt(pack.getAttribute('data-sale-cents') || '0', 10);
    const display = money(saleCents);

    const btnPrice = form.querySelector('[data-ctr-btn-price]');
    if (btnPrice) btnPrice.textContent = '| ' + display;

    updateShipHint(form, saleCents);

    const stickyPrice = root.querySelector('[data-sticky-price]');
    if (stickyPrice) stickyPrice.textContent = display;

    root.setAttribute('data-active-qty', String(sharedQty));
    root.setAttribute('data-display-price', display);
    root.setAttribute('data-display-cents', String(saleCents));
  }

  function syncAll() {
    getForms().forEach(syncForm);
  }

  root.addEventListener('change', (e) => {
    const t = e.target;
    if (!t) return;
    if (t.matches('[data-pack-radio]')) {
      sharedQty = parseInt(t.getAttribute('data-qty') || '1', 10) || 1;
      syncAll();
    }
  });

  function initGallery() {
    const gallery = root.querySelector('[data-serene-gallery]');
    if (!gallery) return;

    const mainImg = gallery.querySelector('[data-gallery-main]');
    const thumbs = Array.from(gallery.querySelectorAll('[data-thumb-index]'));
    if (!mainImg || !thumbs.length) return;

    let index = 0;

    function goTo(i) {
      index = Math.max(0, Math.min(i, thumbs.length - 1));
      const btn = thumbs[index];
      const src = btn.getAttribute('data-full-src');
      if (src) mainImg.src = src;
      thumbs.forEach((t, n) => t.classList.toggle('is-active', n === index));
    }

    thumbs.forEach((btn) => {
      btn.addEventListener('click', () => {
        goTo(parseInt(btn.getAttribute('data-thumb-index'), 10) || 0);
      });
    });

    const prev = gallery.querySelector('[data-gallery-prev]');
    const next = gallery.querySelector('[data-gallery-next]');
    if (prev) prev.addEventListener('click', () => goTo(index - 1));
    if (next) next.addEventListener('click', () => goTo(index + 1));

    goTo(0);
  }

  function initSticky() {
    const sticky = root.querySelector('[data-sticky-atc]');
    const sentinel = root.querySelector('[data-atc-sentinel]');
    if (!sticky || !sentinel) return;

    const io = new IntersectionObserver(
      ([entry]) => {
        const show = !entry.isIntersecting && window.matchMedia('(min-width: 990px)').matches;
        sticky.hidden = !show;
        sticky.classList.toggle('is-visible', show);
      },
      { rootMargin: '0px', threshold: 0 }
    );
    io.observe(sentinel);

    sticky.querySelectorAll('[data-sticky-atc-btn]').forEach((btn) => {
      btn.addEventListener('click', (e) => {
        e.preventDefault();
        const mainForm = root.querySelector(
          'product-form-component.serene-product-form:not(.serene-product-form--compact) form'
        );
        if (mainForm) {
          const submitBtn = mainForm.querySelector('[type="submit"]');
          if (submitBtn) submitBtn.click();
        }
      });
    });
  }

  root.querySelectorAll('[data-scroll-buy]').forEach((el) => {
    el.addEventListener('click', (e) => {
      const href = el.getAttribute('href');
      if (href && href.startsWith('#')) {
        e.preventDefault();
        const target = document.querySelector(href);
        if (target) target.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    });
  });

  root.querySelectorAll('.ctr-collapsible-row__toggle, .pdp-faq-item__trigger').forEach((trigger) => {
    trigger.addEventListener('click', () => {
      const row = trigger.closest('.ctr-collapsible-row');
      if (row && !trigger.closest('details')) {
        row.classList.toggle('is-open');
      }
    });
  });

  function initReviews() {
    const dataEl = root.querySelector('[data-review-data]');
    const list = root.querySelector('[data-review-list]');
    if (!dataEl || !list) return;

    let reviews = [];
    try {
      reviews = JSON.parse(dataEl.textContent || '[]');
    } catch (e) {
      reviews = [];
    }

    let filter = 'all';
    let query = '';
    let sort = 'recent';

    function render() {
      let items = reviews.slice();
      if (filter === '5') items = items.filter((r) => r.rating === 5);
      else if (filter === '4') items = items.filter((r) => r.rating === 4);
      else if (filter === '3') items = items.filter((r) => r.rating <= 3);

      if (query) {
        const q = query.toLowerCase();
        items = items.filter(
          (r) =>
            (r.title || '').toLowerCase().includes(q) ||
            (r.body || '').toLowerCase().includes(q) ||
            (r.name || '').toLowerCase().includes(q)
        );
      }

      if (sort === 'highest') items.sort((a, b) => b.rating - a.rating);
      else if (sort === 'lowest') items.sort((a, b) => a.rating - b.rating);
      else items.sort((a, b) => (b.date || '').localeCompare(a.date || ''));

      const empty = root.querySelector('[data-review-empty]');
      if (empty) empty.hidden = items.length > 0;

      list.innerHTML = items
        .map(
          (r) =>
            `<article class="serene-review-card" data-rating="${r.rating}">
              <div class="serene-review-card__head">
                <div class="serene-review-card__avatar" aria-hidden="true">${(r.name || '?').charAt(0)}</div>
                <div class="serene-review-card__meta">
                  <div class="serene-review-card__name-row">
                    <strong>${r.name || ''}</strong>
                    <span class="serene-review-card__verified">
                      <svg width="12" height="12" viewBox="0 0 12 12" fill="none" aria-hidden="true"><circle cx="6" cy="6" r="6" fill="#22C55E"/><path d="M3.5 6L5.25 7.75L8.5 4.5" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>
                      Verified Buyer
                    </span>
                  </div>
                  <div class="serene-review-card__stars-date">
                    <span class="serene-review-card__stars" aria-label="${r.rating} out of 5">${'★'.repeat(r.rating || 0)}${'☆'.repeat(5 - (r.rating || 0))}</span>
                    <time>${r.date || ''}</time>
                  </div>
                </div>
              </div>
              <h3 class="serene-review-card__title">${r.title || ''}</h3>
              <p>${r.body || ''}</p>
            </article>`
        )
        .join('');
    }

    const writeBtn = root.querySelector('[data-review-write]');
    if (writeBtn) {
      writeBtn.addEventListener('click', () => {
        window.alert('Thanks for your interest! Review submission will open after purchase verification.');
      });
    }

    root.querySelectorAll('[data-rating]').forEach((chip) => {
      chip.addEventListener('click', () => {
        root.querySelectorAll('[data-rating]').forEach((c) => c.classList.remove('is-active'));
        chip.classList.add('is-active');
        filter = chip.getAttribute('data-rating') || 'all';
        render();
      });
    });

    const search = root.querySelector('[data-review-search]');
    if (search) {
      search.addEventListener('input', () => {
        query = search.value || '';
        render();
      });
    }
    const sortEl = root.querySelector('[data-review-sort]');
    if (sortEl) {
      sortEl.addEventListener('change', () => {
        sort = sortEl.value;
        render();
      });
    }

    render();
  }

  root.querySelectorAll('[data-serene-marquee]').forEach((track) => {
    if (track.dataset.cloned) return;
    track.dataset.cloned = 'true';
    track.innerHTML = track.innerHTML + track.innerHTML;
  });

  function openCartDrawer() {
    const drawer = document.querySelector('cart-drawer-component');
    if (drawer && typeof drawer.open === 'function') {
      drawer.open();
      return true;
    }
    return false;
  }

  document.addEventListener('cart:update', (event) => {
    if (event?.detail?.data?.didError) return;
    // Ensure drawer opens after PDP add-to-cart
    openCartDrawer();
  });

  initGallery();
  initSticky();
  initReviews();
  syncAll();
})();
